import { useQuery } from '@tanstack/react-query';

import {
  getSystemCampaignsByParty,
  type GetSystemCampaignsByPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useSystemCampaigns(
  partyId: string,
  options?: QueryOptions<GetSystemCampaignsByPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.systemCampaigns(partyId),
    queryFn: async () => {
      const result = await getSystemCampaignsByParty(
        {
          path: {
            party_id: partyId,
          },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
